// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      actionWords: [
        "Assess",
        "Check",
        "Function Test",
        "Inspect",
        "Inspect & Test",
        "Review",
        "Replace",
        "Refurbish",
        "Sample",
        "Test"
      ],
      // eslint-disable-next-line
      maintAssuranceType: [
        "FA",
        "FM",
        "IC",
        "ST",
        "TA"
      ],
      // eslint-disable-next-line
      maintStrategyType: [
        "Assurance"
      ],
      // eslint-disable-next-line
      maintStrategyDriver: [
        "Compliance",
        "Reliability",
        "Safety"
      ],
      // eslint-disable-next-line
      maintStrategyType: [
        "CBM",
        "HBM",
        "IFT",
        "RBI",
        "RBM",
        "RTF",
        "SBI",
        "TBM"
      ],
      // eslint-disable-next-line
      maintPlanType: [
        "Time"
      ],
      // eslint-disable-next-line
      maintPlanExecutionModel: [
        "Area",
        "Campaign",
        "Facility",
        "Package",
        "Project",
        "Section",
        "System",
        "Type",
        "Unit",
        "Vendor"
      ],
      // eslint-disable-next-line
      maintPlanOperationalAccess: [
        "Control",
        "Instrument",
        "General",
        "Offline",
        "Online",
        "Shutdown",
        "Window"
      ],
      // eslint-disable-next-line
      maintPlanComplexity: [
        "Advanved",
        "Professional",
        "Simple"
      ],
      // eslint-disable-next-line
      maintStrategyFreq: [
        "NA",
        "1W",
        "2W",
        "1M",
        "3M",
        "6M",
        "9M",
        "1Y",
        "2Y",
        "3Y",
        "4Y",
        "5Y",
        "6Y",
        "7Y",
        "8Y",
        "9Y",
        "10Y",
        "11Y",
        "12Y"
      ]
    };
  }
};
